
import { Observable } from 'rxjs';
import { CreateAccountModel, LoginAccountModel, LoginAccountResult, NotLoggedInReturnModel } from '../Elearning-Models';
import { IAPIService } from './API-Service/IAPIService';

export class CreateAccountService {
    constructor(private apiService: IAPIService) {

    }


  //Naiya
  CreateAccount(data: CreateAccountModel ): Observable<boolean> {
    return this.apiService.CreateAccount(data);
  }

  EditUser(data: CreateAccountModel): Observable<boolean> {
    return this.apiService.EditUser(data);
  }

  GetUserDetailsForEdit(): Observable<CreateAccountModel> {
    return this.apiService.GetUserDetailsForEdit();
  }

  ValidateUsername(email: string):Observable<boolean>{
    return this.apiService.ValidateUserName(email);
  }

  LoginUser(data: LoginAccountModel): Observable<LoginAccountResult>{
    return this.apiService.LoginUser(data);
  }

  IsLoggedIn(): Observable<NotLoggedInReturnModel>{
    return this.apiService.IsLoggedIn();
  }
}
